<script setup lang="ts">
import type { PropType } from "vue";

const props = defineProps({
  item: {
    type: [Object, String] as PropType<any>,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
});
</script>

<template>
  <template v-if="level > 0">
    <component
      :is="item"
      size="5"
      fill="currentColor"
      stroke-width="1.5"
      class="iconClass"
    />
  </template>
  <template v-else>
    <component :is="item" size="20" stroke-width="1.5" class="iconClass" />
  </template>
</template>
